//BASE
import Vue from 'vue'
import Vuex from 'vuex'
// import AreasStore from './components/AreasStore'
import { router } from './router'
import VueRouter from 'vue-router'
import App from './App.vue'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import Skeleton from 'vue-loading-skeleton';

//
import { BootstrapVue } from 'bootstrap-vue'
//
import Vue2TouchEvents from 'vue2-touch-events'
/////////////////////
Vue.use(Vuex)
// ROUTER
Vue.use(VueRouter)
// import { IonicVueRouter } from "@ionic/vue";
// Vue.use(IonicVueRouter);
//CONFIG
Vue.config.productionTip = false;
Vue.use(Ionic);
//
Vue.use(BootstrapVue)
//
Vue.use(Vue2TouchEvents)
//
Vue.use(Skeleton)
//
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
//
Vue.use(require('vue-moment'));


//IONIC
import Ionic from "@ionic/vue"
import "@ionic/core/css/core.css"
import "@ionic/core/css/ionic.bundle.css"

//FONT AWESOME -> https://dev.to/karlodelarosa3/font-awesome-5-as-a-component-in-vue-js-7ho
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(fab, fas, far, fal,fad);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.ignoredElements = [/^ion-/]

if ('serviceWorker' in navigator) {
    // Enregister le service worker
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
        // Vérifiez si le navigateur a rechargé la page
        if (!navigator.serviceWorker.controller) {
            console.log('on a pas encore de serviceworker');
            notifyUserAndUpdate(this);
            return;
        }

        registration.addEventListener('updatefound', function() {
            console.log('updatefound');
            // Le service worker change de statut
            registration.installing.addEventListener('statechange', function() {
                console.log('stateChange');
                // Si le nouveau service worker est installé
                if (this.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // Un nouveau service Worker est prêt, affichez le toast
                        notifyUserAndUpdate(this);
                    } else{
                        // C'est une nouvelle installation, aucun toast nécessaire
                        console.log('Service worker a bien été installé');
                    }
                }
            });
        });

        /*console.log('registration', registration);
        // Vérifiez si une nouvelle version du Service-Worker est prête
        if (registration.waiting) {
            notifyUserAndUpdate(registration.waiting);
            return;
        }

        // Vérifiez si une nouvelle version du Service-Worker est en installation
        if (registration.installing) {
            trackInstalling(registration.installing);
            return;
        }

        // Suivre l'installation des nouvelles versions
        registration.addEventListener('updatefound', function() {
            trackInstalling(registration.installing);
        });*/
    }).catch(function(error) {
        console.log('Service Worker registration failed:', error);
    });

    // Si le navigateur est rechargé, mettre à jour le Service-Worker
    navigator.serviceWorker.addEventListener('controllerchange', function() {
        console.log('controllerchange');
        window.location.reload();
    });
}

// Une fonction pour suivre quand le nouvel Service-Worker est en installation
/*function trackInstalling(worker) {
    worker.addEventListener('statechange', function() {
        if (worker.state === 'installed') {
            notifyUserAndUpdate(worker);
        }
    });
}*/

// Cette fonction sert à notifier l'utilisateur et à mettre à jour le Service-Worker
function notifyUserAndUpdate(worker) {
    // Vous pouvez ici insérer votre logique d'affichage de notification
    // Par exemple avec Vue-notification ou Vue-toasted
    var event = new Event('newServiceWorker');
    window.dispatchEvent(event);

    if (worker) {
        worker.postMessage({action: 'skipWaiting'});
    }
}

//SCSS
import './assets/scss/_main.scss'


//Initialisation de l'intercepteur de requetes
import {InitSecureRequestInterceptor} from "./interceptors/SecureRequestInterceptor";
InitSecureRequestInterceptor();

//INTEGRATION
new Vue({
  store: require('./components/AreasStore.js'),
  el: '#app',
  router,
  render: h => h(App)
})


